import { EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { Step, StepIdentifier, StepContext, StepItemContent } from './step';
import { StepperStateService } from './stepper-state.service';

export abstract class BaseStep implements Step {

  static InputProperties: string[] = ['step'];
  static OutputProperties: string[] = ['changes'];

  changes = new EventEmitter<boolean>();

  private _contextChanges = new BehaviorSubject<StepContext>(null);
  public contextChanges = this._contextChanges.asObservable();

  private _context: StepContext;
  get context(): StepContext {
    return this._context;
  };
  set context(value: StepContext) {
    this._context = value;
    this._contextChanges.next(value);
  }

  public step: StepItemContent;

  constructor(
    public stepStateService: StepperStateService,
    protected changeDetectorRef: ChangeDetectorRef) {

    this.stepStateService.stateChanges
      .pipe(untilDestroyed(this))
      .subscribe(p => {
        this.changeDetectorRef.markForCheck();
      });
  }

  public saveChanges(options: { next?: boolean } = {}): void { }

  private _isValid: boolean = false;
  get isValid(): boolean {
    return this._isValid;
  }

  public markAsValid(): void {
    this._isValid = true;
    this.changes.emit(this._isValid);
  }

  public markAsInvalid(): void {
    this._isValid = false;
    this.changes.emit(this._isValid);
  }

  public activateStep(): void {
    this.changes.emit(this.isValid);
  }

  public deactivateStep(): void { }

  public getNextStep(): StepIdentifier | null {
    return null;
  }

  isStepComplete(): Observable<boolean> {
    return of(true);
  }

  public ngOnDestroy(): void { }

  public nextStepClick = () => { };

  public registerNextStep(fn: () => void ): void {
    this.nextStepClick = fn;
  }
}